import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    redirect: '/goods',
    children: [
      {
        path: '/goods',
        name: 'goods',
        component: () => import('../views/AllPage/GoodsView.vue'),
        // redirect: '/doupo',
        // children: []
      },
      {
        path: '/order',
        name: 'order',
        component: () => import('../views/AllPage/OrderView.vue')
      },
      {
        path: '/my',
        name: 'my',
        component: () => import('../views/AllPage/MyView.vue'),
        children:[]
      },
    ]
  },
  {
    path: '/Login',
    name: 'login',
    component: () => import('../views/AllPage/mainPage/LoginView.vue')
  },
  {
    path: '/Sign',
    name: 'sign',
    component: () => import('../views/AllPage/mainPage/SignView.vue')
  },
  {
    path: '/myGoods',
    name: 'myGoods',
    component: () => import('../views/AllPage/mainPage/userPage/myGoods.vue')
  },
  {
    path: '/errSub',
    name: 'errSub',
    component: () => import('../views/AllPage/mainPage/userPage/errSub.vue')
  },
  {
    path: '/setUp',
    name: 'setUp',
    component: () => import('../views/AllPage/mainPage/userPage/setUpPage.vue')
  },
  {
    path: '/goodsAdmin',
    name: 'goodsAdmin',
    component: () => import('../views/AllPage/mainPage/adminPage/goodsAdmin.vue'),
    meta: { requiresAuth: true, roles: ['admin'] }  // 管理员访问
  },
  {
    path: '/userAdmin',
    name: 'userAdmin',
    component: () => import('../views/AllPage/mainPage/adminPage/userAdmin.vue'),
    meta: { requiresAuth: true, roles: ['admin'] }  // 管理员访问
  },
  {
    path: '/errAdmin',
    name: 'errAdmin',
    component: () => import('../views/AllPage/mainPage/adminPage/errAdmin.vue'),
    meta: { requiresAuth: true, roles: ['admin'] }  // 管理员访问
  },
]

const router = new VueRouter({
  // mode: 'history',   // 注销后默认hash模式
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // const user = JSON.parse(localStorage.getItem('userInfo'));  // 获取当前用户
  const user = store.state.userInfo;
  const isAuthenticated = localStorage.handingtoken ? true : false;  // 判断用户是否已登录
  const requiredRoles = to.meta.roles;  // 获取当前路由所需的角色

  if (to.meta.requiresAuth && !isAuthenticated) {
    // 如果需要认证并且用户没有登录
    next({ name: 'login' });
  } else if (requiredRoles && requiredRoles.length > 0) {
    // 如果路由有角色限制
    if (requiredRoles.includes(user.iden)) {
      next();  // 用户角色符合要求，允许访问
    } else {
      next({ name: 'my' });  // 角色不符合要求，重定向到首页或其他页面
    }
  } else {
    next();  // 没有角色限制，直接允许访问
  }
});

export default router
